import * as React from "react";
import Render from "source/app/presentation/Shared/Render";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import { BookOfMindQuote } from "motw_core/DTOs/BookOfMindQuote";

export const NoSearchResultsText = ({
    searchText,
    displayedQuotes,
}: {
    searchText: string;
    displayedQuotes: BookOfMindQuote[];
}) => (
    <Render
        id="noSearchResults"
        when={searchText !== "" && displayedQuotes.length === 0}
    >
        <span {...Style(`noSearchResults`, { color: `dimgray` })}>
            No search results
        </span>
    </Render>
);
